import { render } from "./ConfirmLotto.vue?vue&type=template&id=2c4caaa0"
import script from "./ConfirmLotto.vue?vue&type=script&lang=js"
export * from "./ConfirmLotto.vue?vue&type=script&lang=js"

import "./ConfirmLotto.vue?vue&type=style&index=0&id=2c4caaa0&scope=true&lang=css"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__